// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__rGzcl","infoBtn":"quickbooks_infoBtn__2pBu8","formBox":"quickbooks_formBox__2kwv8","formFooter":"quickbooks_formFooter__aiIBs"};